import { createContext, useContext, useState, useMemo } from 'react';

export const TemplateContext = createContext(null);

export const TemplateProvider = ({ children, participantsFetchEnabled }) => {
    const [ownerSub, setOwnerSub] = useState('');

    // participantsFetchEnabled: when set (true/false), gates participants API fetch in ViewTemplates. undefined = allow fetch.
    const value = useMemo(
        () => ({ ownerSub, setOwnerSub, participantsFetchEnabled }),
        [ownerSub, participantsFetchEnabled]
    );

    return (
        <TemplateContext.Provider value={value}>
            {children}
        </TemplateContext.Provider>
    );
};

export const useTemplateContext = () => useContext(TemplateContext);